import React, { createContext, useContext, useState } from 'react';
import { logout as logoutApi } from '../services/api';

const AuthContext = createContext(null);

const TOKEN_KEY    = 'ldm_token';
const USERNAME_KEY = 'ldm_username';
const ROLE_KEY     = 'ldm_role';
const EXPIRES_KEY  = 'ldm_expires_at';

function readStoredAuth() {
  try {
    const token     = localStorage.getItem(TOKEN_KEY);
    const username  = localStorage.getItem(USERNAME_KEY);
    const role      = localStorage.getItem(ROLE_KEY);
    const expiresAt = localStorage.getItem(EXPIRES_KEY);

    if (!token || !expiresAt) return null;

    // Treat stored expiresAt as "yyyy-MM-dd HH:mm:ss" from the backend
    const expiry = new Date(expiresAt.replace(' ', 'T'));
    if (isNaN(expiry) || expiry < new Date()) {
      clearStorage();
      return null;
    }

    return { token, username, role };
  } catch {
    return null;
  }
}

function clearStorage() {
  [TOKEN_KEY, USERNAME_KEY, ROLE_KEY, EXPIRES_KEY].forEach(k =>
    localStorage.removeItem(k)
  );
}

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(readStoredAuth);

  const login = ({ token, username, role, expiresAt }) => {
    localStorage.setItem(TOKEN_KEY,    token);
    localStorage.setItem(USERNAME_KEY, username);
    localStorage.setItem(ROLE_KEY,     role);
    localStorage.setItem(EXPIRES_KEY,  expiresAt || '');
    setAuth({ token, username, role });
  };

  const logout = async () => {
    try {
      await logoutApi();
    } catch {
      // Ignore API errors — always clear the session locally
    } finally {
      clearStorage();
      setAuth(null);
    }
  };

  const isAdmin = auth?.role === 'ROLE_ADMIN';

  return (
    <AuthContext.Provider value={{ auth, login, logout, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
